module.exports = __webpack_public_path__ + "img/stop-14.d4aabdb5.jpg";